import React from "react"

interface IProp {
  clientName: string
  clientTitle: string
  content: string
  classname: string
}
const SlideItem: React.FC<IProp> = ({
  clientName,
  clientTitle,
  content,
  classname,
}) => (
  <div className={classname}>
    <div className="has-text-centered">
      <span className="is-inline-block px-2">{clientName}</span>
      <span className="is-inline-block px-2">{clientTitle}</span>
    </div>
    <p>{content}</p>
  </div>
)

export default SlideItem
